<template>
    <div
        class="l-row m-card"
        :class="{ 'm-card--toggle': list.length > 6, 'm-card--active': toggle }"
    >
        <div class="l-row__column m-card__column">
            <div class="l-row m-card__container">
                <div class="l-row__column">
                    <div
                        v-if="title"
                        class="m-card__header"
                    >
                        <a-icon
                            v-if="icon"
                            :icon="icon"
                            class="m-card__headerIcon"
                        />
                        <h2 class="a-title m-card__title">{{ title }}</h2>
                    </div>
                    <p
                        class="m-card__item"
                        v-for="(item, idx) in list"
                        v-bind:key="idx"
                        @click="onClick(item.id)"
                    >
                        {{ item.name }}
                        <template v-if="item._joinData && item._joinData.quantity">
                            - {{ item._joinData.quantity }}{{ item._joinData.unit }}
                        </template>
                    </p>
                </div>
            </div>
        </div>
        <div
            v-if="list.length > 6"
            class="m-card__more"
            @click="toggle = !toggle"

        ></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            toggle: false
        }
    },
    props: {
        list: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        routerSingleName: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick(id) {
            if(this.routerSingleName && id) {
                this.$router.push({ name: this.routerSingleName, params: { id } }).catch(() => {})
            }
        }
    }
}
</script>